/*
 * Roshfort: keep footer accordions (Quick links / Information / Contact us)
 * open once a visitor taps them open on a phone.
 *
 * The theme's "footer-details" custom element (class FooterDetails) force-
 * closes an already-open accordion every time a "resize" or "unmatchSmall"
 * event fires while the small-screen media query still matches. On real
 * phones, tapping a summary to open an accordion changes the page's height,
 * which commonly triggers a "resize" event on its own (e.g. the mobile
 * browser's address bar collapsing/expanding as the layout shifts) - so the
 * accordion the visitor just opened snaps shut again immediately. That is
 * exactly the "Contact Us accordion auto-collapses when clicked" bug.
 *
 * Fix: only let the theme's forced-close logic run the first time the small
 * breakpoint is (re)entered - not on every subsequent resize while already
 * on a small screen. That still auto-collapses everything on first load /
 * on a genuine desktop->mobile transition, but once a visitor opens one by
 * hand it stays open until they close it themselves.
 *
 * This has to patch the class BEFORE theme.js registers it as a custom
 * element, because FooterDetails' constructor does
 * `window.addEventListener("resize", this.load.bind(this))` - binding a
 * reference to whatever `this.load` is at construction time. Patching the
 * prototype after elements already exist would be too late; those elements
 * would keep calling the original, unpatched function. So this script must
 * load and run before assets/theme.js.
 */
(function () {
  if (!window.customElements || typeof customElements.define !== "function") {
    return;
  }

  var nativeDefine = customElements.define.bind(customElements);

  customElements.define = function (name, elementClass, options) {
    if (
      name === "footer-details" &&
      elementClass &&
      elementClass.prototype &&
      typeof elementClass.prototype.load === "function" &&
      !elementClass.prototype.__rfAccordionPatched
    ) {
      var originalLoad = elementClass.prototype.load;

      elementClass.prototype.load = function () {
        var isSmallScreen = !!(
          window.theme &&
          window.theme.config &&
          window.theme.config.mqlSmall
        );

        if (isSmallScreen && this.__rfWasSmall) {
          // Still on a small screen since the last check - this is a
          // spurious resize (or similar re-trigger), not a real breakpoint
          // crossing. Leave the accordion exactly as the visitor left it.
          return;
        }

        this.__rfWasSmall = isSmallScreen;
        return originalLoad.apply(this, arguments);
      };

      elementClass.prototype.__rfAccordionPatched = true;
    }

    return nativeDefine(name, elementClass, options);
  };
})();
